import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import PageFourConstructionValueTableRow from './pageFourConstructionValueTableRow';
import PageFourConstructionValueTableHeader from './pageFourConstructionValueTableHeader';

const styles = StyleSheet.create({
    headerContainer: {
        marginTop: 10,
        justifyContent: 'flex-start',
        width: '80%',
        paddingTop: 30,
        paddingLeft: 30,
        paddingRight: 30,
    },
    constructionValue: {
        marginTop: -30,
        paddingBottom: 3,
        fontFamily: 'Helvetica',
        fontSize: 16,
        color: '#F66616',
    },
    viewContainer: {
        borderRadius: 6,
        backgroundColor: '#F8F8F8',
        width: 537,
        paddingTop: 2,
        paddingBottom: 3,
    },
});

const PageFourConstructionValue = ({ prequalifyData }) => (
    <View style={styles.headerContainer}>
        <Text style={styles.constructionValue}>Construction Value</Text>
        <View style={styles.viewContainer}>
            <PageFourConstructionValueTableHeader />
            <PageFourConstructionValueTableRow items={prequalifyData?.data?.constructionRecordsForPdf} />
        </View>
    </View>
);

export default PageFourConstructionValue;
